/** Angular */
import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
/** Functions */
import { bydTranslateInitializer } from './functions/byd-translate-initializer.function';
/** Services */
import { BydTranslateService } from './services/byd-translate.service';
/** Configs */
import { BYD_TRANSLATE_INJECTION_TOKEN } from './configs/byd-translate-injection-token';
/** Interfaces */
import { BydTranslateInterface } from './interfaces/byd-translate.interface';

/**
 * The beyond translate module.
 *
 * @see https://github.com/sxd-platform/byd-front-libs/blob/master/projects/byd-lib-translate/README.md
 * @property forRoot
 * @module BydTranslateModule
 */
@NgModule({
  imports: [HttpClientModule],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: bydTranslateInitializer,
      deps: [BydTranslateService],
      multi: true,
    },
  ],
})
export class BydTranslateModule {
  /**
   * Use this method in the root module to provide the BydTranslateService.
   *
   * @param bydTranslate the translate data.
   *
   * Set the default used language from AppModule location
   * @example BydTranslateModule.forRoot({
   *            language: 'en'
   *      }),
   * @returns ModuleWithProviders `BydTranslateModule`
   */
  static forRoot(bydTranslate?: BydTranslateInterface): ModuleWithProviders<BydTranslateModule> {
    return {
      ngModule: BydTranslateModule,
      providers: [
        {
          provide: BYD_TRANSLATE_INJECTION_TOKEN,
          useValue: bydTranslate,
        },
      ],
    };
  }
}
